import { useLocation } from 'react-router';
import { PAP_AFFILIATE_QUERY_PARAM } from '@mm/constants/referrals';
import { ambassadorMap } from './components/LoginLayout/AffiliateLanding/useAffiliateData/use-affiliate-data';
import { extractAffiliateData } from '@mm/utils';

const validAmbassadorAffiliateIds = ambassadorMap.map(({ affiliateId }) =>
  affiliateId.toLowerCase(),
);

export const useAmbassadorId = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const queryAffiliateId = query.get(PAP_AFFILIATE_QUERY_PARAM);

  const affiliateData = extractAffiliateData();

  const source = [queryAffiliateId, affiliateData?.code]
    .filter(Boolean)
    .map((s: string) => s.toLowerCase());

  const [affiliateId] = source.filter(id =>
    validAmbassadorAffiliateIds.includes(id.toLowerCase()),
  );

  return affiliateId;
};
